import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ROUTES } from '@/constants/routes';

interface NavItem {
  icon: React.ElementType;
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { icon: Home, label: 'Dashboard', path: ROUTES.STUDENT.HOME },
  { icon: BookOpen, label: 'DVSA Skills', path: ROUTES.COMMON.DVSA_SKILLS },
];

export const BottomNav: React.FC = () => {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#E8EDF4] bg-white/85 backdrop-blur-xl shadow-[0_-2px_16px_rgba(15,23,42,0.06)] max-w-[100vw]"
      style={{
        paddingBottom: 'max(8px, env(safe-area-inset-bottom, 0px))',
        paddingLeft: 'env(safe-area-inset-left, 0px)',
        paddingRight: 'env(safe-area-inset-right, 0px)'
      }}
    >
      <div className="grid grid-cols-2 h-16 w-full mx-auto px-3 max-w-md">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center gap-1 my-1.5 rounded-2xl transition-all duration-200",
                isActive ? "bg-[#0F172A]/[0.05]" : "hover:bg-[#F1F5F9]"
              )}
            >
              <Icon
                className={cn(
                  "h-5 w-5 transition-colors duration-200",
                  isActive ? "text-[#0F172A]" : "text-[#94A3B8]"
                )}
              />
              <span
                className={cn(
                  "text-[11px] transition-colors duration-200",
                  isActive ? "text-[#0F172A] font-semibold" : "text-[#94A3B8] font-medium"
                )}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
